import React from 'react';

interface ChatSuggestionsProps {
  suggestions: string[];
  onSuggestionClick: (suggestion: string) => void;
  visible?: boolean;
  isInitialQuickReplies?: boolean;
}

export const ChatSuggestions: React.FC<ChatSuggestionsProps> = ({
  suggestions,
  onSuggestionClick,
  visible = true,
  isInitialQuickReplies = false
}) => {
  // サジェストがない場合は表示しない
  if (!suggestions || suggestions.length === 0) {
    return null;
  }

  // 可視/不可視で排他的な完全文字列を使う（Tailwind の purge は文字列連結を追えないため）
  const containerClassName = visible
    ? 'sticky bottom-0 bg-white border-t border-t-gray-200 p-4 m-0 w-full z-10 opacity-100 visible transition-[opacity,visibility] duration-300 ease-[ease] shadow-[0_-2px_10px_rgba(0,0,0,0.05)]'
    : 'sticky bottom-0 bg-white border-t border-t-gray-200 p-4 m-0 w-full z-10 opacity-0 invisible transition-[opacity,visibility] duration-300 ease-[ease] shadow-[0_-2px_10px_rgba(0,0,0,0.05)]';

  // 初回クイックリプライかどうかでタイトルを変更
  const title = isInitialQuickReplies 
    ? '✨ 何かご質問はありますか？'
    : '💡 こんなことも聞いてみませんか？';

  return (
    <div className={containerClassName}>
      <div className="text-[14px] text-gray-500 mb-3 font-medium">
        {title}
      </div>

      <div className="flex flex-wrap gap-2 justify-start">
        {suggestions.map((suggestion, index) => (
          <button
            key={index}
            className="bg-gray-50 border border-gray-200 rounded-[20px] px-4 py-2 text-[14px] text-gray-700 cursor-pointer transition-all duration-200 ease-[ease] whitespace-nowrap overflow-hidden text-ellipsis max-w-[300px] min-w-[80px] hover:bg-gray-100 hover:border-gray-300 hover:-translate-y-px hover:shadow-[0_2px_4px_rgba(0,0,0,0.1)] active:translate-y-0 active:shadow-[0_1px_2px_rgba(0,0,0,0.1)] disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none disabled:shadow-none"
            onClick={() => onSuggestionClick(suggestion)}
            type="button"
            title={suggestion} // 長いテキストの場合はツールチップで全文表示
          >
            {suggestion}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ChatSuggestions;
